import { client } from 'src/enviroment/api/axios'
import { useQuery } from '@tanstack/react-query'
import { Query } from '../index'
import { useTenantStore } from 'src/enviroment/store/tenentStore'
import { ProjectsQueryParams } from 'src/types/projects'

export const locationRouterKeys = {
  locations: 'location.projectLocations',
} as const

export const locationRouter = {
  projectLocations: {
    useQuery: (params: ProjectsQueryParams, opts?: Query<string[]>) => {
      const tenantId = useTenantStore((state) => state.currentTenant?.id)

      return useQuery<string[]>({
        queryKey: [locationRouterKeys.locations, tenantId, params],
        queryFn: async () => {
          return (
            await client.get<string[]>(`/tenants/${tenantId}/projects:locations`, {
              params,
            })
          ).data
        },
        enabled: Boolean(tenantId),
        ...opts,
      })
    },
  },
}
